import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../components/AppShell';
import { Field } from '../components/ui';
import { useAuth } from '../store/auth';
import { useAction } from '../lib/hooks';

export default function Register() {
  const register = useAuth((s) => s.register);
  const { busy, error, run } = useAction();
  const [form, setForm] = useState({
    workshopName: '',
    name: '',
    position: 'Workshop Supervisor',
    email: '',
    password: '',
  });

  const set = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const tooShort = form.password.length > 0 && form.password.length < 10;

  return (
    <AuthLayout title="Set up your workshop">
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s4)' }}
        onSubmit={(e) => {
          e.preventDefault();
          run(() => register(form));
        }}
      >
        {error ? (
          <div className="notice notice-danger" role="alert">
            {error}
          </div>
        ) : null}

        <Field label="Workshop name" hint="Printed on inspection sheets as the inspection organisation.">
          <input className="input" required value={form.workshopName} onChange={set('workshopName')} />
        </Field>

        <Field label="Your name">
          <input className="input" required autoComplete="name" value={form.name} onChange={set('name')} />
        </Field>

        <Field label="Your position" hint="Appears under your signature.">
          <input className="input" value={form.position} onChange={set('position')} />
        </Field>

        <Field label="Email">
          <input
            className="input"
            type="email"
            required
            autoComplete="username"
            inputMode="email"
            autoCapitalize="off"
            autoCorrect="off"
            value={form.email}
            onChange={set('email')}
          />
        </Field>

        <Field
          label="Password"
          hint="At least 10 characters. A short phrase works well."
          error={tooShort ? 'Too short — 10 characters minimum.' : null}
        >
          <input
            className="input"
            type="password"
            required
            autoComplete="new-password"
            value={form.password}
            onChange={set('password')}
          />
        </Field>

        <button className="btn btn-primary btn-block" type="submit" disabled={busy || tooShort}>
          {busy ? 'Creating…' : 'Create workshop'}
        </button>
      </form>

      <p className="small muted" style={{ textAlign: 'center' }}>
        Already set up? <Link to="/login" style={{ color: 'var(--brand)', fontWeight: 600 }}>Sign in</Link>
      </p>
    </AuthLayout>
  );
}
